export default function getValidationErrors(err) {
  const validationErrors = {};

  err.inner.forEach((err) => {
    validationErrors[err.path] = err.message;
  });

  return validationErrors;
}
